<template>
  <div id="app">
    <template v-if="showLayout">
      <Navbar />
      <router-view />
      <AppFooter />
    </template>

    <AdminLayout v-else-if="showAdminLayout">
      <router-view />
    </AdminLayout>

    <router-view v-else />
  </div>
</template>

<script>
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import AdminLayout from './components/AdminLayout.vue'
import Navbar from './components/NavbarSec.vue'
import AppFooter from './components/FooterSec.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    AppFooter,
    AdminLayout,
  },
  setup() {
    const route = useRoute()

    const adminLayoutPaths = ['/admin', '/admin/orders', '/admin/order-summary', '/admin/messages']
    const hiddenPaths = ['/login', '/signup', '/verifyEmail', '/admin', '/admin/orders', '/admin/order-summary', '/admin/messages', '/admin/login', '/chef/dashboard', '/deposit']

    const showLayout = computed(() => !hiddenPaths.includes(route.path))
    const showAdminLayout = computed(() => adminLayoutPaths.includes(route.path))

    // Clear booking localStorage on page refresh/load
    const clearBookingData = () => {
      const bookingKeys = [
        'bookingName',
        'bookingPhone',
        'bookingEmail',
        'bookingGuests',
        'bookingDate',
        'reservationId',
        'date',
        'duration',
        'selectedTable',
        'selectedTableName',
        'cart'
      ];
      
      bookingKeys.forEach(key => {
        localStorage.removeItem(key);
      });
      
      console.log('Booking data cleared on page refresh');
    };

    // Clear checkout localStorage on page refresh/load
    const clearCheckoutData = () => {
      const checkoutKeys = [
        'redirectToCheckout',
        'redirectToBookingDuration',
        'checkoutCart',
        'checkoutDeliveryAddress',
        'checkoutSpecialRequest',
        'checkoutPaymentMethod',
        'cart'
      ];
      
      checkoutKeys.forEach(key => {
        localStorage.removeItem(key);
      });
      
      console.log('Checkout data cleared on page refresh');
    };

    // Clear data when page loads/refreshes
    clearBookingData();
    clearCheckoutData();

    return {
      showLayout,
      showAdminLayout,
    }
  }
}
</script>

<style>
body {
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #1F1F1F;
}

/* Print styles */
@media print {
  /* Hide navbar and footer when printing */
  nav, 
  .navbar,
  footer,
  .footer,
  button,
  .no-print {
    display: none !important;
  }
  
  /* Ensure the receipt content is properly styled for printing */
  .receipt-print {
    background: white !important;
    color: black !important;
    box-shadow: none !important;
    border: 1px solid #ccc !important;
  }
  
  /* Remove any background images or colors for clean printing */
  body {
    background: white !important;
    color: black !important;
  }
  
  /* Ensure proper page breaks */
  .receipt-print {
    page-break-inside: avoid;
  }
}
</style>
